export const checklistItemExpectedMeasurementText = (ckItem) => {
  const m = ckItem.measurement;
  return `${m.idealValue} ${m.unit} + ${m.toleranceUpperBound}, - ${m.toleranceLowerBound}`;
};

export const checklistItemMeasurementTakenText = (measurementTaken, ckItem) => {
  const m = ckItem.measurement;
  return `${measurementTaken} ${m.unit}`;
};
